import ReadWriteRecipientViewState from '../store/schema/ReadWriteRecipientViewState';
import RecipientDragData from '../store/schema/RecipientDragData';
import { RecipientType } from '../store/schema/RecipientType';
import { observer } from 'mobx-react';
import Draggable from 'owa-dnd/lib/components/Draggable';
import DragViewState from 'owa-dnd/lib/store/schema/DragViewState';
import DropEffect from 'owa-dnd/lib/store/schema/DropEffect';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import * as React from 'react';

const styles = require('./DraggableRecipient.scss');

const DRAG_X_OFFSET = -10;
const DRAG_Y_OFFSET = 5;

export interface DraggableRecipientProps {
    recipientType: RecipientType;
    recipient: ReadWriteRecipientViewState;
    dragViewState: DragViewState;
    removeRecipientAction: (recipient: ReadWriteRecipientViewState) => void;
}

@observer
export default class DraggableRecipient extends React.Component<DraggableRecipientProps, any> {
    render() {
        return (
            <Draggable
                classNames={styles.draggableContainer}
                dragViewState={this.props.dragViewState}
                canDrag={() => this.canDrag()}
                getDragData={() => this.getDragData()}
                getDragPreview={this.getDragPreview}
                xOffset={DRAG_X_OFFSET}
                yOffset={DRAG_Y_OFFSET}
                onDragEnd={this.onDragEnd}>
                {this.props.children}
            </Draggable>
        );
    }

    private onDragEnd = (dragData: RecipientDragData, dropEffect?: DropEffect) => {
        // If succesfully dropped, the dropEffect should be set to 'move'
        if (dropEffect && dropEffect == 'move') {
            this.props.removeRecipientAction(this.props.recipient);
        }
    };

    private canDrag(): boolean {
        const { recipient } = this.props;
        return !(recipient.blockWellItemRemoval && recipient.shouldBlockSelection);
    }

    private getDragData(): DragData {
        const recipientDragData: RecipientDragData = {
            itemType: DraggableItemTypes.ReadWriteRecipient,
            recipientViewState: this.props.recipient,
            recipientType: this.props.recipientType,
        };

        return recipientDragData;
    }

    private getDragPreview(dragData: RecipientDragData): HTMLElement {
        const elem = document.createElement('div');
        elem.innerText = dragData.recipientViewState.displayText;
        return elem;
    }
}
